/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.12.0
 * @since 1.0.0
 */
import { ILogoutStartSuccessful } from '../../pages/PageAuth/types/authTypes';
import { createAction } from '../app/createAction';
import {
    CHANGE_STATUS_NOTIFICATION,
    CLOSE_NOTIFICATION,
    GET_NOTIFICATIONS_FAILED,
    GET_NOTIFICATIONS_START,
    OPEN_NOTIFICATION,
} from './notificationConstants';
import {
    INotificationChangeStatusPayload,
    INotificationErrorPayload,
    INotificationPayload,
    TNotificationChangeStatusAction,
    TNotificationCloseAction,
    TNotificationErrorAction,
    TNotificationGetAction,
    TNotificationLocationChangeAction,
    TNotificationOpenAction,
} from './types/actionTypes';
import { ENotificationPlace, INotification } from './types/notificationTypes';

/*
* -------------------------------------------
*       OPEN NOTIFICATION
* -------------------------------------------
*/

export const openNotification = (notification: INotification | INotification[], place = ENotificationPlace.global):
    TNotificationOpenAction =>
    createAction(OPEN_NOTIFICATION, { notification, place });

export const getNotificationsStart = (payload: INotificationPayload = { place: ENotificationPlace.global }):
    TNotificationGetAction => createAction(GET_NOTIFICATIONS_START, payload);

/*
* -------------------------------------------
*       CLOSE NOTIFICATION
* -------------------------------------------
*/

export const closeNotificationAction = (payload: INotificationPayload  = { place: ENotificationPlace.global }):
    TNotificationCloseAction => createAction(CLOSE_NOTIFICATION, payload);

/*
* -------------------------------------------
*       ERROR NOTIFICATION
* -------------------------------------------
*/

export const getNotificationsFailed = (payload: INotificationErrorPayload): TNotificationErrorAction =>
    createAction(GET_NOTIFICATIONS_FAILED, payload);

/*
* -------------------------------------------
*       CHANGE STATUS NOTIFICATION
* -------------------------------------------
*/

export const notificationChangeStatus = (payload: INotificationChangeStatusPayload): TNotificationChangeStatusAction =>
    createAction(CHANGE_STATUS_NOTIFICATION, payload);

export type TNotificationActionTypes =
    ILogoutStartSuccessful
    | TNotificationCloseAction
    | TNotificationChangeStatusAction
    | TNotificationErrorAction
    | TNotificationOpenAction
    | TNotificationLocationChangeAction
    ;
